import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'friendlyDateFormatPipe',
})
export class FriendlyDateFormatPipe implements PipeTransform {
  transform(value: number) {
    const dif = Math.floor((Date.now() - value) / 1000 / 86400);
    if (dif < 30) {
      return convertToNiceDate(value);
    } else {
      const datePipe = new DatePipe('en-US');
      return 'Just now';// datePipe.transform(value, 'MMM-dd-yyyy');
    }
  }
}

function convertToNiceDate(time: number) {
  const date = new Date(time);
  const diff = (new Date().getTime() - date.getTime()) / 1000;
  const daydiff = Math.floor(diff / 86400);

  if (isNaN(daydiff) || daydiff < 0 || daydiff >= 31) {
    return 'Just now';
  }
  
  return (
    (daydiff === 0 &&
      ((diff < 60 && 'Just now') ||
        (diff < 120 && '1 minute ago') ||
        (diff < 3600 && Math.floor(diff / 60) + ' minutes ago') ||
        (diff < 7200 && '1 hour ago') ||
        (diff < 86400 && Math.floor(diff / 3600) + ' hours ago'))) ||
    (daydiff === 1 && 'Yesterday') ||
    (daydiff < 7 && daydiff + ' days ago') ||
    (daydiff < 31 && Math.ceil(daydiff / 7) + ' weeks ago')
  );
}
